export const BitCanneryContractABI = require('../build/contracts/CryptoLegacy.json')
export const RegistryContractABI = require('../build/contracts/Registry.json')
